export default {
    data() {
        return {
            sysName:"",
        }
    },
    onLoad() {
    },
    created() {
        let user =  JSON.parse(window.sessionStorage.getItem("user"));
        // let roles =  JSON.parse(window.sessionStorage.getItem("roles"));
        this.sysName = user.nickName;
        // this.sysName = this.sysName.replaceAll("李远", "huangbailun");
        // console.log(this.sysName);
        // console.log(roles);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

    }
}